import { Injectable } from '@angular/core';
import { Provider } from '../provider';
import { IControlList } from 'src/app/models/control-list';

@Injectable()
export class ControlListService extends Provider<IControlList> {
  protected url = "control-lists";
}
